var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 3.388V0C4.4 0.55 0 5.291 0 11C0 16.709 4.4 21.45 9.9 22V18.612C6.6 18.084 3.3 14.872 3.3 11C3.3 7.128 6.6 3.916 9.9 3.388ZM18.667 9.9H22C21.483 4.4 17.6 0.517 12.1 0V3.388C15.4 3.861 18.194 6.6 18.667 9.9ZM12.1 18.612V22C17.6 21.483 21.483 17.6 22 12.1H18.667C18.194 15.4 15.4 18.139 12.1 18.612Z",
    fill: "#338FCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderIcon);
export default __webpack_public_path__ + "static/media/headerIcon.8c84d7fb80f55310b6498e0ab9db3641.svg";
export { ForwardRef as ReactComponent };